<template>
  <div class="full-screen">
    <sui-header>Please confirm your subscription</sui-header>
    <p>
      By clicking on Confirm Subscription you agree to begin a monthly auto-renewing subscription.
      You also agree to the <a href="https://caite.co/m/caite-sim-plan-services-terms-and-conditions/" target="_blank">Càite SIM Plan Services Terms and Conditions</a>.
    </p>
    <p>You will be charged £7.99 immediately and again on the same day every month until you cancel your subscription.</p>
    <p>You can manage and cancel your subscriptions by going to your Account page at any time.</p>
    <div class="actions">
      <sui-button type="button" class='pay-with-stripe' @click='close'>Cancel</sui-button>
      <sui-button type="button" class='pay-with-stripe' @click='confirm' primary>Confirm Subscription</sui-button>
    </div>
    <div class="spacemaker mobile only"></div>

    </div>
</template>

<script>
    export default {
      name: "PurchaseConfirmation",
      props: ["device"],
      methods: {
        confirm() {
          this.$emit('close', true)
        },
        close() {
          this.$emit('close', false)
        }
      }
    }
</script>

<style scoped>
  .spacemaker {
    height: 250pt;
  }
</style>
